import { startComponent } from "./start.component";
import _ from "lodash";

export const startStateName = "app.start";

export const startState = ($stateProvider) => {
	"ngInject";

	$stateProvider.state({
		url: "/?preserveFields",
		name: startStateName,
		params: {
			preserveFields: null,
		},
		component: startComponent.name,
		resolve: {
			removeCache: ($stateParams, appCache) => {
				const { preserveFields } = $stateParams;
				let keepFields = ["config"];
				if (preserveFields) {
					keepFields = _.union(keepFields, preserveFields);
				}
				appCache.clearExcept(keepFields);
			},
		},
	});
};



// WEBPACK FOOTER //
// ./src/app/components/start/start.state.js